// 购物车订单详情接口
export function cartBuy(params) {
  return this.fetch({
    method: 'get',
    platformCode: true,
    url: 'mall-server/api/order/v3/cartBuy',
    params
  });
}
// web版获取微信支付URL接口
export function webPay(data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/oss/pay/webPay',
    data
  });
}
// 批量根据弹窗活动code给微信用户或者导购员发放优惠卷
export function sendAllBonusType(data) {
  return this.fetch({
    method: 'POST',
    url: 'api/acts/popup/v1/sendAllBonusType',
    data
  });
}
// 根据微信unionid或者empno获取当前用户待领取活动类型下的优惠卷,已登录情况下剔除掉酷开账号已领取的优惠卷
export function unclaimedBonusList(params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/act/coupon/v1/coupon-center',
    params
  });
}
export function queryUserBonusByPlatformCode(params) {
  return this.fetch({
    method: 'GET',
    platformCode: true,
    url: 'mall-server/api/act/coupon/v1/list',
    params
  });
}
// 购买成功任务完成弹框
// export function circumstance(data) {
//   return this.fetch({
//     method: 'POST',
//     url: 'wx-server/integral/task/v1/query/task/circumstance',
//     data
//   });
// }
